export default theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },

  smallerTableCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '7vw',
    color: theme.palette.text.disabled,
  },
  largerTableCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '13vw',
    color: theme.palette.text.disabled,
  },
  editButton: {
    color: theme.palette.primary.main,
  },
  excludeButton: {
    color: theme.palette.common.black,
  },
  actionsTableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '2px',
  },
  boxStyle: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    width: '100%',
  },
  boxButtonsStyle: {
    display: 'flex',
    flexDirection: 'row',
    gap: '2px',
    width: '100%',
    justifyContent: 'space-between',
  },
  buttonStyle: {
    height: '4vh',
    width: '20vw',
  },
  regrasCampanha: {
    display: 'flex',
    flexDirection: 'row',
    gap: '2px',
    width: '100%',
    alignItems: 'center',
  },
  tableCellWrap: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxWidth: 200,
  },
  divider: {
    marginTop: '0.5rem',
    marginBottom: '0.969rem',
    color: theme.palette.primary.main,
  },
  spanValues: {
    color: theme.palette.text.disabled,
    paddingLeft: '8px',
  },
  progressWrapper: {
    height: '100%',
    paddingTop: '3rem',
    paddingBottom: '1.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  whiteBorderBottom: {
    borderBottom: 'none !important',
  },
  paymentTableRowStyle: {
    '&:hover': {
      backgroundColor: '#EDE9E5',
    },
    backgroundColor: '#F3F0EC',
  },
  firstRowStyle: {
    '& td, & th': {
      borderTop: `1px solid ${theme.palette.serena.dark}`,
    },
  },
  lastRowStyle: {
    '& td, & th': {
      borderBottom: `1px solid ${theme.palette.serena.dark} !important`,
    },
  },
  allRowsStyle: {
    '& td, & th': {
      borderBottom: `1px solid ${theme.palette.serena.dark} !important`,
    },
  },
  headRowStyle: {
    '& td, & th': {
      borderBottom: `1px solid ${theme.palette.serena.dark} !important`,
    },
  },
});
